<template>
  <v-select
    id="sel"
    :items="finishes"
    item-value="key"
    item-text="name"
    label="Настройки подсветки"
    dense
    hide-details
    outlined
    :menu-props="{
      bottom: true,
      offsetY: true,
      transition: 'scale-transition',
    }"
    single-line
    class="py-2 px-0"
    @change="changed"
    v-model="selected"
  >
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selected: [],
      finishes: [
        { key: "", name: "" },
        { key: "F", name: "Фаталити" },
        { key: "B", name: "Бруталити" },
        { key: "FB", name: "F + B" },
        { key: "FBR", name: "F + B + R" },
      ],
    };
  },
  methods: {
    ...mapActions(["addHighlight"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      // console.log("Changed:" + this.selected);
      this.addHighlight({ type: "finish_coefs", value: this.selected });
    },
  },

  created() {
    let settings = this.getSettings().highlights;
    if (settings.finish_coefs == "") {
      return;
    }
    let value = settings.finish_coefs;
    // console.log("VALUE: " + value);
    for (const item of this.finishes) {
      if (item.key == value) this.selected = value;
    }
  },
};
</script>

<style scoped>
#sel {
  max-width: 70px;
}
</style>
